import { Component, Input, OnInit } from '@angular/core';
import { AuthoringModeService } from '../../../shared/services/authoring-mode.service';
import { ReducerUtilityService } from '../../../shared/utility-services/reducer-utility.service';
import { PlansStateStructure } from '../configs/interfaces/plansStateStructure.interface';

@Component({
    selector: 'app-plan-change-content',
    templateUrl: './plan-change-content.component.html',
    styleUrls: ['./plan-change-content.component.scss'],
    standalone: false
})
export class PlanChangeContentComponent implements OnInit {

  @Input() isPlanChange: string;

  isAuthoring: boolean;
  showContent: boolean;

  constructor(
    private reducerUtilService: ReducerUtilityService,
    private authoringMode: AuthoringModeService
  ) { }

  ngOnInit(): void {
    this.isAuthoring = this.authoringMode.getAuthoringMode();
    let planState: PlansStateStructure = this.reducerUtilService.getState('Plans');

    this.showContent = this.isPlanChange === 'true' ? planState?.isPlanChange : !planState?.isPlanChange;
  }

}
